module.exports = __webpack_public_path__ + "img/twitter.44ad1c28.svg";